<template>
  <div id="app">
    <home-index></home-index>
  </div>
</template>

<script>
import HomeIndex from "./views/home/index.vue";
export default {
  name: "App",
  components: {
    HomeIndex,
  },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
  scroll-padding-top: 80px;
}
#app {
  font-family: "Microsoft YaHei", Helvetica Neue, Helvetica, PingFang SC,
    Hiragino Sans GB, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  background-color: #fff;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>
